export type Theme = 'light' | 'dark'

export function getPageTheme(pathname: string, defaultTheme: Theme): Theme {
  if (pathname === '/photographs') return 'light'
  if (pathname === '/explore/gsl') return 'dark'
  if (pathname === '/explore/tattoo') return 'dark'
  if (pathname === '/explore/date-picker-sandbox') return 'dark'
  return defaultTheme
}

export function getThemeClasses(theme: Theme): string {
  return theme === 'light' ? 'bg-white text-black' : 'bg-black text-white'
}

